import { ROUTE } from '@/constants'
import { SimType } from '@/types'

export const buildSimOnlyRedirectPageURL = (
  sku: string,
  selectedSimType: SimType,
): string => {
  const params = new URLSearchParams({ selectedSimType })
  return `${ROUTE.SIM_ONLY_PAGE_REDIRECT}/${encodeURIComponent(sku)}?${params.toString()}`
}
